import React from 'react'

const Skills = ({leftinfo}) => {
  return (
    <>
    {leftinfo.skills.map((skill) =>{
    return(
        <div className='skill-container'>
            {skill.title && <h1 className='skill-title'>{skill.title}</h1>}
            {skill.skill && <p className='skills'>{skill.skill}</p>}
        </div>
        )
    })}
    </>
  )
}

export default Skills